import { defineComponent } from 'vue';

export default defineComponent({
  name: 'our-history',
  computed: {
    falkenURL() {
      return process.env.VUE_APP_FALKEN_URL
    }
  }
});